<div class="ui-g">
  <div class="ui-g-12">
    <div class="ui-g card card-w-title">
      <div class="ui-g-12">
        <h1>Dispute List</h1>
        <form (ngSubmit)="search()" style="width: 100%">
          <div class="ui-g filterPanel form-group">
            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <span class="md-inputfield filterItem">
                <input
                  name="jobnumber"
                  type="text"
                  pInputText
                  [(ngModel)]="filterVal.filters.jobNumber.value"
                />
                <label>Job No</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <span class="md-inputfield filterItem">
                <input
                  name="customer"
                  type="text"
                  pInputText
                  [(ngModel)]="filterVal.filters.customerCompanyName.value"
                />
                <label>Customer</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <span class="md-inputfield filterItem">
                <input
                  name="supplier"
                  type="text"
                  pInputText
                  [(ngModel)]="filterVal.filters.supplierCompanyName.value"
                />
                <label>Supplier</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <p-dropdown
                name="statusDispute"
                [options]="statusDispute"
                [(ngModel)]="filterVal.filters.status.value"
                styleClass="filterItem"
                [style]="{ width: '100%' }"
              ></p-dropdown>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <button
                pButton
                type="button"
                label="Clear"
                class="ui-button btn-to-right"
                (click)="clearFilter(dt)"
              ></button>
              <button pButton type="submit" label="Search" class="ui-button btn-to-right"></button>
            </div>
          </div>
        </form>

        <p-table
          #dt
          [value]="page.items"
          [lazy]="true"
          [rows]="10"
          [responsive]="true"
          [paginator]="true"
          rowHover="true"
          resizableColumns="true"
          [totalRecords]="page.total"
          (onLazyLoad)="onGridLazyLoad($event)"
          [hidden]="!isLoaded"
          [rowsPerPageOptions]="[5, 10, 20]"
          [pageLinks]="3"
          [(selection)]="selectedDispute"
          selectionMode="single"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="jobNumber">Job No</th>
              <th pSortableColumn="customerCompanyName">Customer</th>
              <th pSortableColumn="supplierCompanyName">Supplier</th>
              <th pSortableColumn="createdOn">Created</th>
              <th pSortableColumn="lastUpdated">Last Updated</th>
              <th pSortableColumn="status">Status</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr (dblclick)="onDisputeDetails(item)">
              <td>{{ item.jobNumber }}</td>
              <td>{{ item.customerCompanyName }}</td>
              <td>{{ item.supplierCompanyName }}</td>
              <td>{{ item.createdOn }}</td>
              <td>
                <span>{{ item[item.createdOn] | date : 'dd/MM/yyyy' }}</span>
              </td>
              <td>
                <span>{{ item[item.lastUpdated] | date : 'dd/MM/yyyy' }}</span>
              </td>
              <td>
                <span
                  class="badge"
                  [class.green]="item.status == 1"
                  [class.orange]="item.status == 0"
                >
                  {{ item.status == 1 ? 'Resolved' : 'Open' }}</span
                >
              </td>
            </tr>
          </ng-template>
        </p-table>

        <!-- DATATABLE DEPRECATED --

            <p-dataTabl #dt [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true" [paginator]="true" rowHover="true" resizableColumns="true"
                        [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)" (onRowDblclick)="onDisputeDetails($event)"
                        [hidden]="!isLoaded" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3" [(selection)]="selectedDispute"
                        selectionMode="single" [responsive]="true">
                <p-column field="jobNumber" header="Job No" [sortable]="tru">
                </p-column>
                <p-column field="customerCompanyName" header="Customer" [sortable]="tru"></p-column>
                <p-column field="supplierCompanyName" header="Supplier" [sortable]="tru"></p-column>
                <p-column field="createdOn" header="Created" [sortable]="tru">
                    <ng-template let-col let-dispute="rowData" pTemplate="body">
                        <span>{{ dispute[col.field] | date:'dd/MM/yyyy' }}</span>
                    </ng-template>
                </p-column>
                <p-column field="lastUpdated" header="Last Updated" [sortable]="tru">
                    <ng-template let-col let-dispute="rowData" pTemplate="body">
                        <span>{{ dispute[col.field] | date:'dd/MM/yyyy' }}</span>
                    </ng-template>
                </p-column>
                <p-column field="status" header="Status" [sortable]="tru">
                    <ng-template let-col let-dispute="rowData" pTemplate="body">
                        <span class="badge" [class.green]="dispute.status == 1" 
                              [class.orange]="dispute.status == 0">{{ dispute.status == 1 ? "Resolved" : "Open" }}</span>
                    </ng-template>
                </p-column>               
            </p-dataTable>

            --->
      </div>
      <div class="ui-g-12" style="height: 40px; margin-top: 20px">
        <button
          type="button"
          pButton
          icon="fa ui-icon-edit"
          label="Edit"
          class="ui-button btn-to-right"
          (click)="openDispute(selectedDispute.id)"
          [disabled]="!selectedDispute"
        ></button>
      </div>
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
